import {TableHead, TableRow} from "@mui/material";
import TableCell from "@mui/material/TableCell";
import React from "react";

const InvoiceDetailThead = ({ canDelete }) => {
  return (
    <TableHead>
      <TableRow>
        <TableCell
          sx={{
            color: 'gray'
          }}
        >
          Categoria
        </TableCell>
        <TableCell
          sx={{
            color: 'gray'
          }}
        >
        </TableCell>
        <TableCell
          align="right"
          sx={{
            color: 'gray'
          }}
        >
          Total
        </TableCell>
        {canDelete && <TableCell sx={{ color: 'gray', width: 50 }} />}
      </TableRow>
    </TableHead>
  )
}

export default InvoiceDetailThead